module.exports = "<p>\n  modal-kanban-resend-code works!\n</p>\n"